<template>
  <div class="login relative w-screen h-screen flex items-center justify-center overflow-hidden">
    <div id="particles" class="absolute w-full h-full"></div>
    <div class="login-box animate__animated animate__zoomInDown">
      <div class="flex items-center title-box justify-center">
        <img class="logo" src="@/assets/login/logo.png" alt="">
        <div class="name">用户登录</div>
      </div>
      <el-form class="form-box" :model="loginForm" :rules="rules" ref="loginForm" label-width="0">
        <el-form-item label="账号" prop="username">
          <el-input placeholder="账号" @blur="(e) => {getBandGoogle(e)}" v-model="loginForm.username" clearable>
            <div slot="prefix" class="flex items-center justify-center h-full">
              <img style="width:20px;"  src="@/assets/login/username.png" alt="">
            </div>
          </el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input placeholder="密码" v-model="loginForm.password" clearable show-password>
            <div slot="prefix" class="flex items-center justify-center h-full">
              <img style="width:20px;"  src="@/assets/login/password.png" alt="">
            </div>
          </el-input>
        </el-form-item>
        <el-form-item label="谷歌密钥" v-if="isGoogle == '1'" prop="gg_code">
          <el-input placeholder="谷歌密钥" v-model="loginForm.gg_code" clearable maxlength="6">
            <div slot="prefix" class="flex items-center justify-center h-full">
              <img style="width:20px;"  src="@/assets/login/password.png" alt="">
            </div>
          </el-input>
        </el-form-item>
        <div class="captcha flex justify-between">
          <el-form-item label="验证码" prop="captcha">
            <el-input placeholder="验证码" v-model="loginForm.captcha" clearable>
              <div slot="prefix" class="flex items-center justify-center h-full">
                <img style="width:20px;"  src="@/assets/login/captcha.png" alt="">
              </div>
            </el-input>
          </el-form-item>
          <img @click="captcha" class="captcha-img" :src="captchaImg" alt="" srcset="">
        </div>
        <el-form-item>
          <el-button ref="btn" class="submit-button animate__animated" type="primary" @click="submitForm('loginForm')">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="company">iPay管理后台</div>
  </div>
</template>

<script>
import particles from '@/vendors/particles'
import { captcha, isBindGGAuth } from '@/api/user'
export default {
  data () {
    return {
      captchaImg: '',
      loginForm: {
        username: '',
        password: '',
        gg_code: '',
        captcha: '',
        captcha_key: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        gg_code: [
        { required: true, message: '请输入谷歌密钥', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不少于6个字符', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 4, message: '验证码输入不完整', trigger: 'blur' }
        ]
      },
      isGoogle: '0',
    }
  },
  mounted () {
    window.particlesJS('particles', {
      particles: {
        number: {
          value: 40,
          // 数量
          density: {
            enable: true,
            // 启用粒子的稀密程度
            value_area: 500// 区域散布密度大小
          }
        },
        color: {
          value: '#fff'// 原子的颜色
        },
        shape: {
          type: 'circle',
          // 原子的形状 "circle" ,"edge" ,"triangle" ,"polygon" ,"star" ,"image" ,["circle", "triangle", "image"]
          stroke: {
            width: 0,
            // 原子的宽度
            color: '#fff'// 原子颜色
          },
          polygon: {
            nb_sides: 5// 原子的多边形边数
          }
        },
        opacity: {
          value: 1,
          // 不透明度
          random: true,
          // 随机不透明度
          anim: {
            enable: true,
            // 渐变动画
            speed: 1,
            // 渐变动画速度
            opacity_min: 0,
            // 渐变动画不透明度
            sync: true
          }
        },
        size: {
          value: 3,
          // 原子大小
          random: true,
          // 原子大小随机
          anim: {
            enable: true,
            // 原子渐变
            speed: 2,
            // 原子渐变速度
            size_min: 0.1,
            sync: false
          }
        },
        line_linked: {
          enable: true,
          // 连接线
          distance: 150,
          // 连接线距离
          color: '#fff',
          // 连接线颜色
          opacity: 0.1,
          // 连接线不透明度
          width: 1// 连接线的宽度
        },
        move: {
          enable: true,
          // 原子移动
          speed: 3,
          // 原子移动速度
          direction: 'none',
          // 原子移动方向   "none" ,"top" ,"top-right" ,"right" ,"bottom-right" ,"bottom" ,"bottom-left" ,"left" ,"top-left"
          random: true,
          // 移动随机方向
          straight: false,
          // 直接移动
          out_mode: 'out',
          // 是否移动出画布
          bounce: false,
          // 是否跳动移动
          attract: {
            enable: false,
            // 原子之间吸引
            rotateX: 600,
            // 原子之间吸引X水平距离
            rotateY: 600 // 原子之间吸引Y水平距离
          }
        }
      },
      interactivity: {
        detect_on: 'canvas',
        // 原子之间互动检测 "canvas", "window"
        events: {
          onhover: {
            enable: true,
            // 悬停
            mode: 'bubble'// 悬停模式      "grab"抓取临近的,"bubble"泡沫球效果,"repulse"击退效果,["grab", "bubble"]
          },
          onclick: {
            enable: false,
            // 点击效果
            mode: 'repulse'// 点击效果模式   "push" ,"remove" ,"bubble" ,"repulse" ,["push", "repulse"]
          },
          resize: true// 互动事件调整
        },
        modes: {
          grab: {
            distance: 100,
            // 原子互动抓取距离
            line_linked: {
              opacity: 0.8// 原子互动抓取距离连线不透明度
            }
          },
          bubble: {
            distance: 250,
            // 原子抓取泡沫效果之间的距离
            size: 3,
            // 原子抓取泡沫效果之间的大小
            duration: 2,
            // 原子抓取泡沫效果之间的持续事件
            opacity: 1,
            // 原子抓取泡沫效果透明度
            speed: 3
          },
          repulse: {
            distance: 400,
            // 击退效果距离
            duration: 0.4// 击退效果持续事件
          },
          push: {
            particles_nb: 4// 粒子推出的数量
          },
          remove: {
            particles_nb: 2
          }
        }
      },
      retina_detect: true
    })
  },
  created () {
    this.captcha()
    // document.addEventListener('keyup', this.escEvent)
  },
  // beforeUnmount () {
  //   document.removeEventListener('keyup', this.escEvent)
  // },
  methods: {
    // escEvent () {
    //   if (window?.event?.keyCode === 13) {
    //     this.submitForm('loginForm')
    //   }
    // },
    captcha () {
      captcha().then((res) => {
        this.captchaImg = res.img
        this.loginForm.captcha_key = res.key
      }, () => {
        
      })
    },
    shake () {
      const name = 'animate__headShake'
      const btn = this.$refs.btn.$el
      btn.classList.add(name)
      setTimeout(() => {
        btn.classList.remove(name)
      }, 1000)
    },
    getBandGoogle(e) {
      if(e.target.value) {
        isBindGGAuth({
          username: e.target.value
        }).then(res => {
          this.isGoogle = res.is_binded
        })
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loginForm.gg_code = this.isGoogle == '1' ? this.loginForm.gg_code : undefined
          this.$store.dispatch('login', this.loginForm)
            .then(() => {
              this.$router.push({ path: this.$store.getters.home }, () => {}, () => {})
            }).catch(() => {
              this.shake()
              this.captcha()
            })
        } else {
          this.shake()
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login{
  #particles{
    background-color: #002a56;
    background-image: radial-gradient(#0036b1,#040529);
    z-index: -1;
  }
  .login-box{
    width: 420px;
    background: #fff;
    padding: 40px 40px 20px;
    border-radius: 7px;
    .title-box{
      margin-bottom: 20px;
      .logo{
        height: 30px;
      }
      .name{
        font-weight: 400;
        font-size: 28px;
        color: #666;
        margin-left: 10px;
      }
    }
    .form-box{
      ::v-deep .el-form-item__label{
        height: 0;
        overflow: hidden;
      }
      .captcha{
        .captcha-img{
          width: 110px;
          height: 40px;
        }
      }
      .submit-button{
        width: 100%;
      }
    }

  }
  .company{
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: 0;
    color: #aaa;
    line-height: 70px;
  }
}
</style>
